import { buildCommonGuideSettings, buildThemeSettings } from "./themeHelper.mjs";
import { GuideApiService } from '@ignitesales/neuro-application/src/neuro-guide/services/GuideApiService.mjs';

const onDialogueStateInit = async (neuroState) => {
    const isDevelopmentMode = neuroState?.guideConfigurations?.runMode === 'development';
    const isDemoMode = neuroState?.guideConfigurations?.isDemoMode;
    const themeName = THEME_NAME || 'undefined';
    if (window?.ignite?.userService?.getGuideAttributes) {
        const guideAttributes = await window.ignite.userService.getGuideAttributes();
        const dbThemeSettings = guideAttributes?.themeSettings || {};
        const dbGuideSettings = guideAttributes?.guideSettings || {};
        const themeSettings = buildThemeSettings(themeName, THEME_MANIFEST_CONFIGS || {}, dbThemeSettings, isDevelopmentMode, isDemoMode);
        const commonGuideSettings = buildCommonGuideSettings(dbGuideSettings, isDevelopmentMode, isDemoMode);

        if (guideAttributes?.dialogueApiConfig)
            await GuideApiService.authenicate(guideAttributes.dialogueApiConfig);

        GuideApiService.useUser(neuroState.user);
        GuideApiService.useAnswers(neuroState.answers);

        // Get guideId from user (available from mm-web)
        const guideId = neuroState.user?.guideId || guideAttributes?.guideId;

        // Include guideId in guide configurations for action endpoints
        const guideConfigsWithIds = {
            ...neuroState.guideConfigurations,
            guideId: guideId
        };
        GuideApiService.useGuide(guideConfigsWithIds);

        if (guideId) {
            console.log('GuideApiService configured with guideId:', guideId, '(clientKey will be looked up by middleware)');
        } else {
            console.warn('onDialogueStateInit: guideId not found');
        }

        return {
            ...neuroState,
            themeManifest: THEME_MANIFEST_CONFIGS || {},
            themeName,
            themeSettings,
            user: {
                ...neuroState.user,
                guideId: guideId
            },
            dialogueGuideSettings: {
                ...commonGuideSettings
            },
            guideConfigurations: {
                ...neuroState.guideConfigurations,
                guideId: guideId,
                dialogueApiConfig: guideAttributes?.dialogueApiConfig,
                layouts: guideAttributes?.layouts,
                themeSettings: guideAttributes?.themeSettings
            }
        }
    } else {
        return neuroState;
    }
}

export default onDialogueStateInit;
